import { BaseResponse } from './client-response';

export interface FailureResponseMessageSummary {
  message: string;
  summary: string;
}

export class FailureResponse<T> extends BaseResponse<T> {
  public errorCode: number | string;

  constructor(errorCode: number | string, body: T) {
    super(false, body);
    this.errorCode = errorCode;
  }
}
